<template>
  <div class="modal" @click.self="close">
    <button @click="closeModal()" class="modal__Overlay"></button>
    <success-prompt :updated="updated" :message="prompt.success"></success-prompt>

    <div class="modal__Inner">
      <section class="modal__Post">
        <header class="modal__Header">
          <h1 class="modal__Title">{{ $store.getters.getStringTranslation('mergetags') }}</h1>

          <div class="modal__Meta">
            <ul>
              <li class="modal__MetaItem--Button">
                <button
                  v-if="prompt.save.length > 0"
                  @click="mergeTags()"
                  :disabled="updated === true"
                  class="button--Small"
                >
                  {{ prompt.save }}
                </button>
              </li>
              <li class="modal__MetaItem">
                <button @click="closeModal()" class="modal__MetaLink">
                  <icon name="times"></icon>
                </button>
              </li>
            </ul>
          </div>
        </header>

        <error-prompt class="error--Modal" :errors="errors"></error-prompt>
        <loader class="imageLoader" :loading="loading || updating" />

        <template v-if="loading === false">
          <div class="formSection formSection--MergeTags">
            <div class="formSection__Row">
              <p>
                <label class="formLabel" for="editTitle">{{
                  $store.getters.getStringTranslation('selectTagsMerge')
                }}</label>
                <search-tag
                  :multiple="true"
                  :lang="lang"
                  :tags="fromTags"
                  v-model="merge_tags_ids"
                  :placeholder="$store.getters.getStringTranslation('selectTagsMerge')"
                  :errorMessage="$store.getters.getStringTranslation('tagsNotFound')"
                  :showLabel="false"
                  :limit="false"
                />
              </p>
              <p>
                <label class="formLabel" for="editAbbreviation">{{
                  $store.getters.getStringTranslation('selectTagsToMerge')
                }}</label>
                <search-tag
                  :multiple="false"
                  :lang="lang"
                  :tags="toTags"
                  v-model="merge_to_id"
                  :placeholder="$store.getters.getStringTranslation('selectTagsToMerge')"
                  :errorMessage="$store.getters.getStringTranslation('tagsNotFound')"
                  :showLabel="false"
                  :limit="false"
                />
              </p>
            </div>
          </div>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
import SearchTag from '@/components/editor/blocks/SearchTag.vue'
import Loader from '@/components/partials/Loader.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'
import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'
import HTTP from '@/http-common.js'

export default {
  name: 'EditTag',
  components: {
    SearchTag,
    Loader,
    ErrorPrompt,
    SuccessPrompt,
  },
  props: ['propLanguage', 'queryParams', 'types'],
  data() {
    return {
      fromTags: [],
      toTags: [],
      merge_to_id: null,
      merge_tags_ids: null,
      prompt: {
        save: 'Save',
        success: '',
      },
      parent: null,
      loading: true,
      updating: false,
      updated: false,
      errors: '',
    }
  },
  computed: {
    tags() {
      const tags = this.$store.state.tags.search.tags
      if (tags) return tags
      return []
    },
    lang() {
      if (this.$route.query.lang !== undefined) {
        return this.$route.query.lang
      } else {
        return this.propLanguage
      }
    },
  },
  created() {
    this.loading = false
    this.$router.push({ query: { lang: this.lang } })

    this.prompt.save = this.$store.getters.getStringTranslation('mergetags')
    this.prompt.success = this.$store.getters.getStringTranslation('tagsMerged')

    // Define parent URL
    this.parent = {
      path: this.$route.matched.find((x) => x.parent !== undefined).parent.path,
      query: {
        search: JSON.stringify(this.queryParams),
      },
    }
  },
  methods: {
    mergeTags() {
      this.updating = true

      if (this.merge_tags_ids.includes(this.merge_to_id)) {
        alert('You cant have same tag in tags you want to merge and tag where other tags will be merged')
        this.updating = false
        return
      }

      HTTP.post(`tags/merge`, {
        merge_to_id: this.merge_to_id,
        merge_tags_ids: this.merge_tags_ids,
      }).then(() => {
        this.$store.dispatch('deleteTags', this.merge_tags_ids)
        this.updating = false
        this.updated = true
        setTimeout(() => {
          this.$router.push(this.parent)
        }, 3000)
      })
    },
    closeModal() {
      if (this.changed === true) {
        if (confirm('Are you sure you wish to close the editor? Everything not saved will be lost!')) {
          this.$router.push(this.parent)
        }
      } else {
        this.$router.push(this.parent)
      }
    },
  },
}
</script>
